import { Pipe, PipeTransform } from '@angular/core';

export type CardTypeWordColor = 'default' | 'gold' | 'silver';

export interface CardTypeSegment {
  readonly color: CardTypeWordColor;
  readonly text: string;
}

const GOLD_TOKENS: ReadonlySet<string> = new Set(['DUO', 'GOLD', 'PRO', 'SOLO']);
const SILVER_SCOPE_TOKENS: ReadonlySet<string> = new Set(['DUO', 'SOLO']);
const SILVER_TOKENS: ReadonlySet<string> = new Set(['SILVER']);

const TOKEN_DISPLAY: ReadonlyMap<string, string> = new Map([['CINEPASS', 'CINÉPASS']]);
const TYPE_REMAP: ReadonlyMap<string, string> = new Map([['CINEPASS_PRO', 'CARTE_PRO']]);

@Pipe({
  name: 'cardTypeSegments',
  pure: true,
})
export class CardTypeSegmentsPipe implements PipeTransform {
  transform(type: string | null | undefined): CardTypeSegment[] {
    if (!type) {
      return [];
    }

    const normalized = TYPE_REMAP.get(type) ?? type;
    const tokens = normalized.split('_').filter((token) => token.length > 0);
    const isSilverScoped = tokens.includes('SILVER');

    return tokens.map((token) => ({
      color: this.colorFor(token, isSilverScoped),
      text: TOKEN_DISPLAY.get(token) ?? token,
    }));
  }

  private colorFor(token: string, isSilverScoped: boolean): CardTypeWordColor {
    if (SILVER_TOKENS.has(token)) return 'silver';
    if (isSilverScoped && SILVER_SCOPE_TOKENS.has(token)) return 'silver';
    if (GOLD_TOKENS.has(token)) return 'gold';
    return 'default';
  }
}
